import React from 'react';
import { Col } from 'antd';

import Node from '../Node';

const renderNode = ({ Component, ...props }) => (
  <Col>
    <Component {...props} />
  </Col>
);

export const MixedContent = ({ value, ...props }) => (
  <Node {...props} blocs={value}>{renderNode}</Node>
);

export default MixedContent;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/MixedContent/index.js